<div class="sgt-canal-venda-multiselect">
    <ngx-bootstrap-multiselect
        [settings]="settings"
        [texts]="texts"
        [options]="options"
        [(ngModel)]="idsCanaisVendas"
        (ngModelChange)="onChange()"
        [disabled]="disabled">
    </ngx-bootstrap-multiselect>
</div>
